/*
 * Semantic accents for guest-facing feedback categories.
 *
 * Used by Guest Experience Version 2 to give the default feedback
 * categories purpose-built icons and calm, meaningful accent colours
 * (the reference design's signature "coloured icon tile" look).
 *
 * Presentation only — the category ids and routing are unchanged.
 */
import { UtensilsCrossed, HandHeart, MessageSquareText } from 'lucide-react';

export const CATEGORY_ACCENTS = {
    food: {
        Icon: UtensilsCrossed,
        text: 'text-amber-300',
        chip: 'bg-amber-400/15 border border-amber-300/25',
    },
    service: {
        Icon: HandHeart,
        text: 'text-sky-300',
        chip: 'bg-sky-400/15 border border-sky-300/25',
    },
    other: {
        Icon: MessageSquareText,
        text: 'text-emerald-300',
        chip: 'bg-emerald-400/15 border border-emerald-300/25',
    },
};

export const DEFAULT_ACCENT = CATEGORY_ACCENTS.other;

export const getCategoryAccent = (id) => CATEGORY_ACCENTS[id] || DEFAULT_ACCENT;
